// extracted by mini-css-extract-plugin
module.exports = {"SettingsIntro":"SettingsForm_SettingsIntro__KUuRt"};